import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';

const HelpLink = styled.p`
  margin: 0;
  Button {
    color: inherit;
    font-size: inherit;
    padding: 0 !important;
    height: auto;
    text-decoration: underline;
    &:hover {
      color: inherit;
    }
  }
`;

export const BillingHelpMessage = () => {
  const openChat = useCallback(() => {
    window.fcWidget?.open();
  }, []);

  return (
    <HelpLink>
      <FormattedMessage
        id="billing.help.text"
        values={{
          link: (chunks) => (
            <Button type="link" onClick={openChat}>
              {chunks}
            </Button>
          ),
        }}
      />
    </HelpLink>
  );
};
